export const CATEGORY_VEHICLE = ["1", "2", "3"];